// Liste restreinte de pays — les plus communs en premier
export interface NationalityOption {
  value: string
  label: string
}

export const Nationalities: NationalityOption[] = [
  // Pays prioritaires
  { value: 'FR', label: 'France' },
  // Autres pays courants
  { value: 'ZA', label: 'Afrique du Sud' },
  { value: 'DE', label: 'Allemagne' },
  { value: 'DZ', label: 'Algérie' },
  { value: 'AR', label: 'Argentine' },
  { value: 'AU', label: 'Australie' },
  { value: 'BE', label: 'Belgique' },
  { value: 'BR', label: 'Brésil' },
  { value: 'CA', label: 'Canada' },
  { value: 'CH', label: 'Suisse' },
  { value: 'CN', label: 'Chine' },
  { value: 'ES', label: 'Espagne' },
  { value: 'US', label: 'États-Unis' },
  { value: 'GB', label: 'Royaume-Uni' },
  { value: 'IN', label: 'Inde' },
  { value: 'IL', label: 'Israël' },
  { value: 'IT', label: 'Italie' },
  { value: 'JP', label: 'Japon' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MA', label: 'Maroc' },
  { value: 'MX', label: 'Mexique' },
  { value: 'NL', label: 'Pays-Bas' },
  { value: 'PT', label: 'Portugal' },
  { value: 'RU', label: 'Russie' },
  { value: 'TN', label: 'Tunisie' },
  // Autres
  { value: 'OTHER', label: 'Autre' },
]

export const Countries = Nationalities
